import React from 'react';

export default function PrivacyPage() {
  return (
    <div className="app-shell legal-page">
      <div className="ambient ambient-left" />
      <div className="ambient ambient-right" />

      <header className="topbar legal-topbar">
        <a className="brand" href="/">
          <img className="brand-mark" src="/SROIK-LOGO.PNG" alt="Sroik" />
        </a>
        <div className="legal-topbar-actions">
          <a className="secondary-action" href="/login">Open workspace</a>
        </div>
      </header>

      <main className="page-view legal-content">
        <div className="page-header">
          <p className="feature-eyebrow">Legal</p>
          <h2>Privacy Policy</h2>
          <p className="page-subtitle">Effective date: April 1, 2026</p>
        </div>

        <article className="workspace-block legal-block">
          <h4>1. Scope</h4>
          <p>
            This policy explains how Sroik collects, uses, discloses, and retains personal and account-related
            information when you use the Sroik website, platform, APIs, and support channels.
          </p>

          <h4>2. Data We Collect</h4>
          <ul className="card-list compact-list">
            <li>Identity and account data: name, email, tenant details, authentication artifacts, and role assignments.</li>
            <li>Service telemetry: usage events, API logs, error traces, and platform performance data.</li>
            <li>Cloud metadata submitted by customers for optimization workflows, including account and project identifiers.</li>
            <li>Billing and operational recommendation metadata generated by analytics pipelines.</li>
          </ul>

          <h4>3. How We Use Data</h4>
          <ul className="card-list compact-list">
            <li>Operate, secure, and improve the platform and related services.</li>
            <li>Authenticate users, enforce access controls, and detect misuse.</li>
            <li>Generate optimization insights, recommendations, and service analytics.</li>
            <li>Meet contractual, legal, tax, and compliance obligations.</li>
          </ul>

          <h4>4. Data Sharing</h4>
          <p>
            We do not sell personal data. We may share data with subprocessors that support hosting, security,
            communications, and analytics, under confidentiality and data-processing obligations.
          </p>

          <h4>5. Data Retention</h4>
          <p>
            We retain information for as long as required to provide services, support legitimate business operations,
            satisfy legal obligations, resolve disputes, and enforce agreements.
          </p>

          <h4>6. Security</h4>
          <p>
            Sroik uses administrative, technical, and organizational controls designed to protect information. No method
            of transmission or storage is guaranteed to be completely secure.
          </p>

          <h4>7. Your Rights</h4>
          <p>
            Depending on applicable law, you may request access, correction, deletion, or export of personal data.
            You may also object to or restrict certain processing activities.
          </p>

          <h4>8. International Transfers</h4>
          <p>
            Data may be processed in countries other than your own. Where required, we implement contractual and
            organizational safeguards for cross-border transfers.
          </p>

          <h4>9. Policy Changes</h4>
          <p>
            We may update this policy periodically. Material changes will be reflected by updating the effective date.
          </p>

          <h4>10. Contact</h4>
          <p>
            Privacy requests and questions: <a href="mailto:support@sroik.com">support@sroik.com</a>
          </p>
        </article>
      </main>
    </div>
  );
}
